import React, { useState, Component, createRef, Fragment } from 'react';
import Axios from 'axios';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { Form, Field, FormSpy } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import createDecorator from 'final-form-focus';
import arrayMutators from "final-form-arrays";
import {
    isRequiredSelectionTos,
    isRequiredStateSelection,
    isRequiredText,
    validateEmail,
    conditionallyRequiredNPINumber,
    isRequiredPhoneNumber
} from './helpers/Validation';
import { stateList, professionalDesignationList, numberTypeList, preferredContactList, interestList, interestList2, preferredMethodOfContact, dayToBeContacted, timeOfTheDay } from './helpers/Form';
import Loader from 'react-loader-spinner';
import { MultiSelect } from "react-multi-select-component";
import MultiselectDropdown from 'multiselect-react-dropdown';


const focusOnErrors = createDecorator();

class SignUpForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            submitted: false,
            validForm: false,
            npiSelected: false
            
        }
        this.interests = []
    }

    onSubmit = async (values) => {
        values.interests = '';
        for(var i=0; i < this.interests.length; i++){
            if(i < this.interests.length -1){
                values.interests += this.interests[i].value+', ';
            }else {
                values.interests += this.interests[i].value;
            }
        }
        
        console.log(JSON.stringify(values));

        const reactState = this;
        let url = "/";
        if(process.env.NODE_ENV === "development") {
          url = "http://localhost:8000/"
        }
        values.formType = 'signUp';
        values.guid = false;
        values.indication = 'Parkinsons';
        try {
            await Axios({
                method: 'post',
                url: url + "api/signup",
                data: values,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            })
            .then(function (res) {
              reactState.setState({
                ...reactState.state,
                submitted: true
              });
            });
            this.scrollToForm();
        }
        catch(errors) {
            console.log("errors", errors)
        }
    }

    scrollToForm = () => {
		this.toTop.current.scrollIntoView({ behavior: "smooth" }); 
    }

    toTop = createRef();

    onSelect = (selectedList, selectedItem)  => {
        
        this.interests.push(selectedItem);
    
    }

    removeNull(array) {
        return array.filter(x => x !== null)
    };
    
    onRemove = (selectedList, removedItem)  => {

       this.interests.splice(
            this.interests.indexOf(removedItem), 1
        );
       this.interests = this.removeNull(this.interests);
     
    }

    render() {
        const { submitted, validForm, npiSelected } = this.state;
        //const [selected, setSelected] = useState([]);
        this.state = {
            options: interestList2
        };
       
        return (
            <div className="grid acadia-form relative sign-up" ref={this.toTop}>
                <a name="sign-up-form"></a>
                <div className="row">
                    <div className="col-lg-12 content-form">
                        <Form
                            onSubmit={this.onSubmit}
                            submitted={submitted}
                            decorators={[ focusOnErrors ]}
                            mutators={{
                                ...arrayMutators
                            }}
                        >
                            {({ handleSubmit, submitting, values }) => (
                                <form onSubmit={handleSubmit}>
                                {submitted && (
                                    <div className="offer-signup" style={{ marginTop: "2em"}}>
                                        <div className="col-lg-8 offset-lg-2">
                                            <h2>Thank you for your interest in NUPLAZID. A sales representative will contact you shortly.</h2>
                                            {/* <a href="/resource-library" className="btn btn-primary large text-center signup-submit resource-guide">
                                                Visit the resource library
                                            </a> */}
                                        </div>
                                    </div>
                                )}
                                {!submitted && (  
                                    <Fragment>
                                        <div className="row">
                                            <div className="col-lg-12 text-left">
                                               
                                                <p class="mt-0">If you'd like to learn more about NUPLAZID, you can request a call or visit from a sales representative. Fill out the form below to contact a representative today.</p>
                                                <p>Report an Adverse Event: If you have an adverse event or product complaint to report, please contact Acadia Pharmaceuticals Inc. at <span className='nowrap'>1-844-422-2342</span>, or the FDA at <span className='nowrap'>1-800-FDA-1088</span> or <a href="#modal-fda-4" data-toggle="modal" class="dont-break-out">www.fda.gov/medwatch</a>.</p>
                                                <p>All fields are required unless marked &ldquo;Optional.&rdquo;</p> 
                                            </div>    
                                        </div>
                                        <div className="row">
                                            <Field className="form-control full-width-input border-0 p-0" name="special" component="input">
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <input {...input}  type="text" style={{opacity: 0, height:"0px"}} tabIndex="-1" />
                                                    </Fragment>
                                                )}
                                            </Field>
                                            <Field className="form-control full-width-input border-0 p-0" name="special" component="input">
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <input {...input}  type="text" style={{opacity: 0, height:"0px"}} />
                                                    </Fragment>
                                                )}
                                            </Field>
                                            <div className="col-lg-10 offset-lg-1">
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field name="firstName" component="input" validate={isRequiredText}>
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className="text-left full-width full-width-input signup-label">First Name</label>
                                                                        <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                        {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field name="lastName" component="input" validate={isRequiredText}>
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className="text-left full-width full-width-input signup-label">Last Name</label>
                                                                        <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                        {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field name="emailAddress" component="input" validate={validateEmail}>
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className="text-left full-width full-width-input signup-label">Email</label>
                                                                        <input {...input} className="form-control full-width-input signup-input" type="text" placeholder="Example: john.smith@gmail.com" />
                                                                        {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field name="phoneNumber" component="input" validate={isRequiredPhoneNumber}>
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className="text-left full-width full-width-input signup-label">Telephone Number</label>
                                                                        <input {...input} className="form-control full-width-input signup-input" type="text" placeholder="" />
                                                                        {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field name="address" component="input" validate={isRequiredText}>
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className="text-left full-width full-width-input signup-label">Address</label>
                                                                        <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                        {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field name="suiteApt" component="input">
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className="text-left full-width full-width-input signup-label">Suite or Apt (Optional)</label>
                                                                        <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                        {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group relative">
                                                            <Field name="city" component="input" validate={isRequiredText}>
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className="text-left full-width signup-label">City</label>
                                                                        <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                        {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                   
                                                        <div className="form-group relative">
                                                            <Field
                                                                name="state"
                                                                component="select"
                                                                validate={isRequiredStateSelection}
                                                            >                        
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className={meta.error && meta.touched ? "error" : ""} htmlFor="state">State</label>
                                                                        <select {...input} className="select-state-css select-css" type="select">
                                                                            <option name="" value="">- Select state -</option>
                                                                            {Object.entries(stateList).map(function(state) {
                                                                                return (<option key={state[0]} name="state" value={state[0]}>{state[1]}</option>);
                                                                            })}
                                                                        </select>
                                                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                       {meta.error && meta.touched && meta.error }          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                   
                                                    </div>
                                                    <div className="col-lg-3">
                                                   
                                                        <div className="form-group relative">
                                                            <Field name="zipCode" component="input" validate={isRequiredText}>
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className="text-left full-width">ZIP Code</label>
                                                                        <input {...input} className="form-control full-width-input signup-input" type="text" />
                                                                        {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                   
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                            <div className="form-group relative">
                                                                <Field
                                                                    name="professionalDesignation"
                                                                    component="select"
                                                                    validate={isRequiredStateSelection}
                                                                >                        
                                                                    {({ input, meta }) => (
                                                                        <Fragment>
                                                                            <label htmlFor="professionalDesignation">Professional Designation</label>
                                                                            <select {...input} className="select-state-css" type="select">
                                                                                <option name="" value="">- Select -</option>
                                                                                {professionalDesignationList.map((professionalDesignation, index) => {
                                                                                    return (<option key={professionalDesignation} name="professionalDesignation" value={professionalDesignation}>{professionalDesignation}</option>);
                                                                                })}
                                                                            </select>
                                                                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                            {meta.error && meta.touched && meta.error }          
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                            </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group relative">
                                                            <Field
                                                                name="numberType"
                                                                component="select"
                                                            >                        
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label htmlFor="numberType">Number Type (Optional)</label>
                                                                        <select {...input} className="select-state-css text-left full-width" type="select">
                                                                            <option name="" value="">- Select -</option>
                                                                            {numberTypeList.map((numberType, index) => {
                                                                                return (<option key={numberType} name="numberType" value={numberType}>{numberType}</option>);
                                                                            })}
                                                                        </select>
                                                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                        {meta.error && meta.touched && meta.error }          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <OnChange name="numberType">
                                                        {(value, previous) => {
                                                            this.setState({
                                                                ...this.state,
                                                                npiSelected: value === "NPI" ? true : false
                                                            });
                                                        }}
                                                    </OnChange>
                                                    <div className="col-lg-3">
                                                        <div className="form-group relative">
                                                            <Field
                                                                name="number"
                                                                component="input" 
                                                                validate={conditionallyRequiredNPINumber(npiSelected ? 1 : 0)}
                                                                key={npiSelected ? 1 : 0}
                                                            >
                                                                {({ input, meta }) => (
                                                                    <Fragment>
                                                                        <label className="text-left full-width">Number {npiSelected ? "" : "(Optional)"}</label>
                                                                        <input 
                                                                            {...input}
                                                                            className="form-control full-width-input signup-input"
                                                                            type="text"
                                                                            maxLength={10}
                                                                            inputMode="numeric"
                                                                        />
                                                                        {meta.error && meta.touched && <span>{meta.error}</span>}          
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div className="row">
                                                    <div className="col">
                                                            <div className="form-group relative">
                                                                <Field  
                                                                    name="interest"
                                                                    component="MultiselectDropdown"
                                                                   
                                                                >                        
                                                                    {({ input, meta }) => (
                                                                        <Fragment>
                                                                            <label htmlFor="interest">I'm interested in (Select all that apply)</label>
                                                                            <MultiselectDropdown  {...input} className="selectpicker"
                                                                                options={this.state.options}
                                                                                placeholder = "- Select -"
                                                                                hidePlaceholder = "true"
                                                                                //datasource={interestList2} // Options to display in the dropdown
                                                                                selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                                                                                onSelect={this.onSelect} // Function will trigger on select event
                                                                                onRemove={this.onRemove} // Function will trigger on remove event
                                                                                //fields={{value:"label", text:"value"}}
                                                                                 displayValue="label" // Property name to display in the dropdown options
                                                                            />

                                                                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                            {meta.error && meta.touched && meta.error }          
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                            </div>
                                                    </div>

                                                   
                                                </div>


                                                <div className="row">
                                                    <div className="col-lg-4">
                                                            <div className="form-group relative">
                                                                <Field  
                                                                    name="bestTime"
                                                                    component="select"
                                                                    validate={isRequiredStateSelection}
                                                                >                        
                                                                    {({ input, meta }) => (
                                                                        <Fragment>
                                                                            <label htmlFor="bestTime">Best time to contact you:</label>
                                                                            <select {...input} className="select-state-css" type="select">
                                                                                <option name="" value="">- Select -</option>
                                                                                {dayToBeContacted.map((day, index) => {
                                                                                    return (<option key={day} name="bestTime" value={day}>{day}</option>);
                                                                                })}
                                                                            </select>
                                                                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                            {meta.error && meta.touched && meta.error }          
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                            </div>
                                                    </div>

                                                    <div className="col-lg-4">
                                                             <div className="form-group relative">
                                                                <Field
                                                                    name="dayTime"
                                                                    component="select"
                                                                    validate={isRequiredStateSelection}
                                                                >                        
                                                                    {({ input, meta }) => (
                                                                        <Fragment>
                                                                            <label htmlFor="dayTime">Time of day:</label>
                                                                            <select {...input} className="select-state-css" type="select">
                                                                                <option name="" value="">- Select -</option>
                                                                                {timeOfTheDay.map((time, index) => {
                                                                                    return (<option key={time} name="dayTime" value={time}>{time}</option>);
                                                                                })}
                                                                            </select>
                                                                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                            {meta.error && meta.touched && meta.error }          
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                            </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                             <div className="form-group relative">
                                                                <Field
                                                                    name="preferredMethodContact"
                                                                    component="select"
                                                                    validate={isRequiredStateSelection}
                                                                >                        
                                                                    {({ input, meta }) => (
                                                                        <Fragment>
                                                                            <label htmlFor="preferredMethodContact">Preferred method of contact:</label>
                                                                            <select {...input} className="select-state-css" type="select">
                                                                                <option name="" value="">- Select -</option>
                                                                                {preferredMethodOfContact.map((methodOfContact, index) => {
                                                                                    return (<option key={methodOfContact} name="preferredMethodContact" value={methodOfContact}>{methodOfContact}</option>);
                                                                                })}
                                                                            </select>
                                                                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                            {meta.error && meta.touched && meta.error }          
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                            </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group relative">
                                                            <label className="inline-checkboxes tos">                            
                                                                <Field
                                                                    name="agreeToTerms"
                                                                    component="input"
                                                                    type="checkbox"
                                                                    validate={isRequiredSelectionTos}
                                                                >
                                                                    {({ input, meta }) => (
                                                                        <Fragment>
                                                                            <input {...input} value={input.value} checked={input.checked} />
                                                                            {meta.error && meta.touched && meta.error }
                                                                        </Fragment>
                                                                    )}
                                                                </Field>{' '}
                                                                <span></span>
                                                                By clicking &ldquo;Submit,&rdquo; I understand and agree to the <a href="https://www.acadia-pharm.com/privacy/" target="_blank">Privacy Policy</a> and <a href="https://www.acadia-pharm.com/terms/" target="_blank">Terms of Use</a>. I agree to be contacted by a NUPLAZID representative and to receive communications from Acadia&nbsp;Pharmaceuticals&nbsp;Inc.
                                                            </label>

                                                         </div>

                                                    </div>
                                                </div>

                                                <div className="form-group relative">
                                                   
                                                    <div className="row button-group">
                                                        <div className="col-sm-6">
                                                            <FormSpy
                                                                subscription={{ valid: true }}
                                                                onChange={props => {
                                                                    this.setState({
                                                                        ...this.state,
                                                                        validForm: props.valid
                                                                    });
                                                                }}
                                                            />
                                                            <button className={"btn align-center submit signup-submit float-right " + (submitting ? "loading" : " ") + (validForm ? " valid-submit" : " ")} type="submit" disabled={submitting}>
                                                                Submit <i class="fa fa-angle-right ml-2 align-middle" style={{position: "relative", top: "-3px"}}></i>
                                                                {submitting && (
                                                                    <Loader
                                                                        type="ThreeDots"
                                                                        color="#FFF"
                                                                        height={100}
                                                                        width={100}
                                                                        className="loading-icon"
                                                                    />
                                                                )}
                                                            </button>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <a className="btn align-center submit signup-submit float-left" style={{margin: "20px 10px"}} href="/" disabled={submitting}>
                                                                Cancel <i class="fa fa-angle-right ml-2 align-middle" style={{position: "relative", top: "-3px"}}></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>    
                                        {process.env.NODE_ENV === "development" && (
                                            <pre style={{marginTop: "100px", marginBottom: "50px"}}>{JSON.stringify(values, 0, 2)}</pre>
                                        )}
                                    </Fragment>
                                )}
                            </form>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        );
    }

    
}

const mapStateToProps = (state) => {
  const { selectedUser, questionOptions } = state;
  return { selectedUser: selectedUser, questionOptions: questionOptions };
}

export default connect(mapStateToProps, actions)(SignUpForm);